// src/math.ts
function isNumber(n) {
  return typeof n === "number";
}
export {
  isNumber
};
